import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCoQYearDataStream } from 'services/glass-management/glassManagement';

export const fetchCoqYear = createAsyncThunk('glass/coqyear/fetch', async (filters) => {
    const res = await getCoQYearDataStream(filters.start);
    return res;
});

export const coqYearSlice = createSlice({
    name: 'glassCoqYear',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        streamChunkReceived: (state, action) => {
            state.data = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCoqYear.pending, state => {
                state.loading = true;
                state.error = null;
                state.data = [];
            })
            .addCase(fetchCoqYear.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload;
            })
            .addCase(fetchCoqYear.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load CoQ Yearly Summary';
                // state.data = null;
            });
    }
});

export const { streamChunkReceived } = coqYearSlice.actions;
export default coqYearSlice.reducer;
